<template>
    <v-form @submit.prevent="addUpdate" ref="form">
        <v-card style="border-radius:4px;">
            <v-toolbar flat height="55px">
                <span class="font-weight-bold ">{{mode}} Pay Grade</span>
                <v-spacer></v-spacer>
                <help-link appId="compensation" pageId="pay-grade" color="black"></help-link>
                <v-btn icon @click.native="closeDialog()" >
                    <v-icon >close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout v-if="mode=='Update'" >
                    <p v-if="error" style="color:red;">{{ errorMessage }}</p>
                    <v-flex xs12 style="padding: 0px 20px 0px 20px; ">
                        <v-alert :value="true" color="warning" icon="warning" outline >
                            Any changes on this Job Grade will reflect on all assigned users.
                        </v-alert>
                    </v-flex>
                </v-layout>
                <v-layout row wrap> 
                    <v-flex xs12 sm4 style="padding: 0px 15px 0px 15px; ">                
                        <v-text-field label="Code" 
                            v-model="code" 
                            :disabled="disabled"
                            :rules="[rules.required]"
                            hint="Sample P1, M2"
                            ></v-text-field>  
                    </v-flex>
                    <v-flex xs12 sm8 style="padding: 0px 15px 0px 15px; ">
                        <v-select
                            label="Role"
                            :items="paygrade_roles"
                            :rules="[rules.required]" 
                            item-text="role"
                            item-value="role"
                            :disabled="disabled"
                            v-model="role"          
                        ></v-select>
                    </v-flex>
                </v-layout>
                <v-layout row wrap> 
                    <v-flex xs12 style="padding: 0px 15px 0px 15px; ">   
                        <v-card class="elevation-0"> 
                            <v-toolbar flat height="35px">
                                <span class="font-weight-bold ">Monthly Basic Salary Range (PHP)</span>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                            <v-card-text>
                                <v-layout row wrap style="margin:-10px 0px -10px 0px;"> 
                                    <v-flex xs12 sm6 style="padding: 0px 5px 0px 5px; ">                
                                        <v-text-field label="From" 
                                            v-model="salaryStart" 
                                            :disabled="disabled"
                                            :rules="[rules.required]"
                                            type="number"
                                            ></v-text-field>  
                                    </v-flex>
                                    <v-flex xs12 sm6 style="padding: 0px 5px 0px 5px; ">                
                                        <v-text-field label="To" 
                                            v-model="salaryEnd" 
                                            :disabled="disabled"
                                            type="number"
                                            :rules="[rules.required]"
                                            ></v-text-field>  
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
                <v-layout row wrap v-if="showComment"> 
                    <v-flex xs12 sm12 style="padding: 20px 15px 0px 15px; ">
                        <v-textarea v-model="description" label="Description" rows="2" color="primary"></v-textarea> 
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon @click="showComment=!showComment" title="Add Comment">
                    <v-icon>comment</v-icon>
                </v-btn>
                <v-btn color="primary" type="submit" :disabled="disabled" :loading="loading" style="color:white">{{mode}}</v-btn>
                <v-btn v-if="mode!='Update'" @click="clearForm" :disabled="disabled" >clear</v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<script>

import payGradeApi from '@/api/paygrade'

export default {
    data () {
        return {
            email: null,
            loading: false,
            disabled: false,
            error: false,
            errorMessage: null,
            rules: {
                required: value => !!value || 'Required field',
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Invalid e-mail.'
                }
            },
            paygrade_roles: [
                {role: 'Rank and File'},
                {role: 'Supervisory'},
                {role: 'Managerial'}
            ],         
            showComment: false,
            job_grade: null,
            mode: null,
            payGradeId: 0,
            code: null,
            role: null,
            description: "",
            salaryStart: null,
            salaryEnd: null,
        }
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },
    methods: {
        formatNumber() {
            this.salaryStart = Number(this.salaryStart).toLocaleString('en');
        },
        numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        setAdd() {
            this.mode = 'Add'
            this.clearForm()
        },
        setUpdate(data) {
            this.mode = 'Update'
            this.payGradeId = data.payGradeId
            this.code = data.code
            this.role = data.role
            this.description = data.description
            this.salaryStart = data.salaryStart
            this.salaryEnd = data.salaryEnd
        },
        async addUpdate() {
            try {
                this.loading = true
                this.disabled = true

                if (this.$refs.form.validate()) {
                    var data = {
                        payGradeId: this.payGradeId,
                        code: this.code,
                        role: this.role,
                        description: this.description,
                        salaryStart: this.salaryStart,
                        salaryEnd: this.salaryEnd
                    }

                    var response = null
                    if (this.mode == 'Add')
                        response = await payGradeApi.add(data)
                    else
                        response = await payGradeApi.update(data)
                        
                    if (response.status == 200) {
                        this.closeDialog()
                        this.$emit('send', true)
                    }
                }

                this.loading = false
                this.disabled = false
            }
            catch (error) {
                this.loading = false
                this.disabled = false
                this.error = true
                this.errorMessage = error
            }
        },
        closeDialog() {
            this.$emit('update:dialogAddEdit', false)
        },
        clearForm() {
            this.$refs.form.reset()
            this.loading = false
            this.error = false
            this.errorMessage = ''
        },
    },
    computed: {
    },
    created() {}
}
</script>